import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Error from 'views/components/Error';
import { PreLoader } from 'views/ui';

const Fetcher = ({ fetchData, label, children }) => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector(({ ui }) => ({
    loading: ui.loading,
    error: ui.error,
  }));

  useEffect(() => {
    dispatch(fetchData());
  }, [fetchData, dispatch]);

  if (loading[label]) return <PreLoader />;
  if (error[label]) return <Error message={error[label]} />;

  return children();
};

export default Fetcher;
